import React from "react";

import { Modal } from "@shared/components";
import { useTranslate } from "@refinedev/core";

import { PromocodeBatchForm } from "../PromocodeBatchForm";
import { CreatePromocodeBatchModalProps } from "./types";
import { useCreatePromocodeBatchModal } from "./controller";

export const CreatePromocodeBatchModal = React.memo(({ modalRef, onComplete }: CreatePromocodeBatchModalProps) => {
  const translate = useTranslate();

  const { methods, mutateAsync, isPending } = useCreatePromocodeBatchModal({
    modalRef,
    onComplete,
  });

  return (
    <Modal
      ref={modalRef}
      title={translate("promocode_batch_admin.titles.create")}
      onConfirm={mutateAsync}
      methods={methods}
      isPending={isPending}
    >
      <PromocodeBatchForm />
    </Modal>
  );
});
